var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M21 12c0 2-3.5 7-9 7s-9-5-9-7 3.5-7 9-7 9 5 9 7Z"}}),_c('path',{attrs:{"d":"M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }